import React from "react";
import { useState } from "react";
import { Pressable } from "react-native";
import { Text } from "@constants/Themed";
import * as Animatable from 'react-native-animatable';
import styles from "@stylesheet";
import { useDispatch, useSelector } from "react-redux";
import { Entypo } from '@expo/vector-icons';
import { themeSelector } from "@reduxLocal/selectors/themeSelector";

interface AddTeamMember {
  addItem?: Function
}

const AddTeamMember = (addItem) => {
  const dispatch = useDispatch();
  const [hoveredState, setHoveredState] = useState(false);
  const theme = themeSelector();

  return (
    <Animatable.View useNativeDriver duration={50} direction={hoveredState ? 'normal' : 'reverse'} transition="backgroundColor" style={{ backgroundColor: hoveredState ? 'rgba(0,0,0,0.2)' : 'transparent', alignSelf: "stretch", minWidth: "100%", borderRadius: 20, borderBottomWidth: 0.1, borderBottomColor: 'rgba(0,0,0,0.1)', flex: 1 }}>
      <Pressable
        onPress={() => { if (addItem) { addItem() } }}
        style={[styles.userMessageListItem, { flex: 1, alignSelf:"stretch", minWidth:"100%", flexDirection: "column" }]}
        onHoverIn={() => { setHoveredState(true) }}
        onHoverOut={() => { setHoveredState(false) }}
      >
        <Entypo name="plus" size={40} color={theme ? "black" : "white"} />
        <Text style={{ textAlign: "center" }}>Add member</Text>
      </Pressable>
    </Animatable.View >
  )
}
export default AddTeamMember;